export default {
  ZH_HK: {
    class_management: "班級管理",
    student_list: "學生列表",
    add_class: "添加班級",
    del: "刪除",
    input_name: "輸入名稱",
    add_student: "添加學生",
    exportAdd: "導表添加",
    exportList: "導出列表",
    class_name: "班級名稱",
    class_code: "班級編號",
    school_name: "學校名稱",
    operate: "操作",
    student_name: "姓名",
    studentUserCode: "學號(帳號)",
    sex: "性別",
    classes: "班級",
    password: "密碼",
    edit: "編輯",
    edit_class: "編輯班級",
    edit_student: "編輯學生",
    confirm: "確認",
    cancel: "取消",
    sex_male: "男",
    sex_female: "女",
    passwordLength: "密碼長度必須在 6 到 20 個字符",
    add_account: "添加帳號",
    import_tips: "可先下載模板，填入信息後，上傳表格",
    import_download: "下載模板",
    upload_excel: "上傳表格",
    download_success: "下載成功",
    download_failed: "下載失敗",
    upload_success: "上傳成功",
    upload_failed: "上傳失敗",
    upload_file_type_error: "只能上傳Excel文件（.xlsx, .xls）",
    upload_file_size_error: "文件大小不能超過10MB",
    upload_file_not_selected: "請先選擇文件",
    class_id_required: "班級ID不能為空",
    export_success: "導出成功",
    export_failed: "導出失敗",
    Manage_Classes: "管理班級",
    Grade_Level: "所屬年級",
    year: "所屬年份",
    status: "狀態",
    remark: "備註",
    all: "所有",
    enable: "在讀",
    enable_text: "在職",
    disable: "停用",
    pick_a_year: "選擇年份",
    yearRequired: "所屬年份不能為空",
    chinese_name: "姓名",
    english_name: "英文姓名",
    studentNumber: "學號",
    studentCode: "學生編號",
    email: "郵箱",
    order: "序號",
    emailInvalid: "郵箱格式不正確",
    emailRequired: "郵箱不能為空",
    download_tips: "上傳表格之前請先選中需要綁定的班級",
    nameRequired: "姓名或英文姓名至少填一項"
  },
  ZH_CN: {
    class_management: "班级管理",
    student_list: "学生列表",
    add_class: "添加班级",
    del: "删除",
    input_name: "输入名称",
    add_student: "添加学生",
    exportAdd: "导表添加",
    exportList: "导出列表",
    class_name: "班级名称",
    class_code: "班级编号",
    school_name: "学校名称",
    operate: "操作",
    student_name: "姓名",
    studentUserCode: "学号(账号)",
    sex: "性别",
    classes: "班级",
    password: "密码",
    edit: "编辑",
    edit_class: "编辑班级",
    edit_student: "编辑学生",
    confirm: "确认",
    cancel: "取消",
    sex_male: "男",
    sex_female: "女",
    passwordLength: "密码长度在 6 到 20 个字符",
    add_account: "添加账号",
    import_tips: "可先下载模板，填入信息后，上传表格",
    import_download: "下载模板",
    upload_excel: "上传表格",
    download_success: "下载成功",
    download_failed: "下载失败",
    upload_success: "上传成功",
    upload_failed: "上传失败",
    upload_file_type_error: "只能上传Excel文件（.xlsx, .xls）",
    upload_file_size_error: "文件大小不能超过10MB",
    upload_file_not_selected: "请先选择文件",
    class_id_required: "班级ID不能为空",
    export_success: "导出成功",
    export_failed: "导出失败",
    Manage_Classes: "管理班级",
    Grade_Level: "所属年级",
    year: "所属年份",
    status: "状态",
    remark: "备注",
    all: "所有",
    enable: "在读",
    enable_text: "在职",
    disable: "停用",
    pick_a_year: "选择年份",
    yearRequired: "所属年份不能为空",
    chinese_name: "姓名",
    english_name: "英文姓名",
    studentNumber: "学号",
    studentCode: "学生编号",
    email: "邮箱",
    order: "序号",
    emailInvalid: "邮箱格式不正确",
    emailRequired: "邮箱不能为空",
    download_tips: "传表格之前请先选中需要绑定的班级",
    nameRequired: "姓名或英文姓名至少填一项"
  },
  EN: {
    class_management: "Class Management",
    student_list: "Student List",
    add_class: "Add Class",
    del: "Delete",
    input_name: "Enter Name",
    add_student: "Add Student",
    exportAdd: "Bulk Import",
    exportList: "Export List",
    class_name: "Class Name",
    class_code: "Class ID",
    school_name: "School Name",
    operate: "Actions",
    student_name: "Name",
    studentUserCode: "Student ID (Username)",
    sex: "Gender",
    classes: "Class",
    password: "Password",
    edit: "Edit",
    edit_class: "Edit Class",
    edit_student: "Edit Student",
    confirm: "Confirm",
    cancel: "Cancel",
    sex_male: "Male",
    sex_female: "Female",
    passwordLength: "The password must be 6 to 20 characters long.",
    add_account: "Add Account",
    import_tips: "Download the template, fill in the information, and upload the file.",
    import_download: "Download Template",
    upload_excel: "Upload Spreadsheet",
    download_success: "Downloaded successfully",
    download_failed: "Download failed",
    upload_success: "Uploaded successfully",
    upload_failed: "Upload failed",
    upload_file_type_error: "Only Excel files (.xlsx, .xls) are allowed",
    upload_file_size_error: "File size cannot exceed 10MB",
    upload_file_not_selected: "Please select a file first",
    class_id_required: "Class ID is required",
    export_success: "Export successful",
    export_failed: "Export failed",
    Manage_Classes: "Manage Classes",
    Grade_Level: "Grade Level",
    year: "Academic Year",
    status: "Status",
    remark: "Remark",
    all: "All",
    enable: "Currently studying",
    enable_text: "Currently employed",
    disable: "Disabled",
    pick_a_year: "Select year",
    yearRequired: "The Academic Year cannot be empty",
    chinese_name: "Name",
    english_name: "English Name",
    studentNumber: "Student Number",
    studentCode: "Student Code",
    email: "Email",
    order: "No.",
    emailInvalid: "Email format is incorrect",
    emailRequired: "Email is required",
    download_tips: "Please select the class you need to bind before uploading the table",
    nameRequired: "Name or English name must fill in at least one"
  },
  es: {
    class_management: "Gestión de grupos",
    student_list: "Lista de estudiantes",
    add_class: "Agregar grupo",
    del: "Eliminar",
    input_name: "Ingrese nombre",
    add_student: "Agregar estudiante",
    exportAdd: "Importación masiva",
    exportList: "Exportar lista",
    class_name: "Nombre del grupo",
    class_code: "Código de grupo",
    school_name: "Nombre de la escuela",
    operate: "Acciones",
    student_name: "Nombre",
    studentUserCode: "Número de matrícula (usuario)",
    sex: "Sexo",
    classes: "Grupo",
    password: "Contraseña",
    edit: "Editar",
    edit_class: "Editar grupo",
    edit_student: "Editar estudiante",
    confirm: "Confirmar",
    cancel: "Cancelar",
    sex_male: "Masculino",
    sex_female: "Femenino",
    passwordLength: "La contraseña debe tener entre 6 y 20 caracteres.",
    add_account: "Agregar cuenta",
    import_tips: "Descargue la plantilla, complete la información y súbala.",
    import_download: "Descargar plantilla",
    upload_excel: "Subir archivo",
    download_success: "Descargado correctamente",
    download_failed: "Error al descargar",
    upload_success: "Cargado correctamente",
    upload_failed: "Error al cargar",
    upload_file_type_error: "Solo se permiten archivos de Excel (.xlsx, .xls)",
    upload_file_size_error: "El tamaño del archivo no puede exceder 10 MB",
    upload_file_not_selected: "Por favor, seleccione un archivo primero",
    class_id_required: "El código del grupo es obligatorio",
    export_success: "Exportación exitosa",
    export_failed: "Error al exportar",
    Manage_Classes: "Gestión de grupos",
    Grade_Level: "Grado escolar",
    year: "Año académico",
    status: "Estado",
    remark: "Nota",
    all: "Todos",
    enable: "Actualmente estudiante",
    enable_text: "Actualmente empleado(a)",
    disable: "Deshabilitado",
    pick_a_year: "Seleccionar año",
    yearRequired: "El año académico no puede estar vacío",
    chinese_name: "Nombre",
    english_name: "Nombre inglés",
    studentNumber: "Número de estudiante",
    studentCode: "Código de estudiante",
    email: "Correo electrónico",
    order: "Número",
    emailInvalid: "El formato de correo electrónico no es correcto",
    emailRequired: "El correo electrónico es obligatorio",
    download_tips: "Antes de subir el archivo, seleccione primero la clase a vincular.",
    nameRequired: "Nombre o nombre en inglés (al menos uno)"
  }
};
